(function () {
  if (customElements.get('announcement-bar-slider')) return;

  class AnnouncementBarSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-bar__track');
      this.slides = this.querySelectorAll('.announcement-bar__slide');
      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.intervalMs = (parseFloat(this.dataset.interval) || 5) * 1000;

      this.querySelectorAll('.announcement-bar__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => {
          this.move(arrow.dataset.direction === 'prev' ? -1 : 1);
          this.startTimer();
        });
      });

      this.startTimer();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.move(1), this.intervalMs);
    }

    move(step) {
      const count = this.slides.length;
      this.index = (this.index + step + count) % count;
      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
})();
